import { Box, Typography } from '@mui/joy';
import { useYear } from '../../providers/YearProvider';

type NewLandingPageHeadingProps = {
	heading?: string;
};

// THIS IS USED FOR UPDATED LANDING PAGE WITH ANALYSIS TILE
export const NewLandingPageHeading = ({ heading }: NewLandingPageHeadingProps) => {
	const { year } = useYear();
	const defaultHeading = `Women, Money, & Politics Watch ${year}`;

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				flexGrow: 1,
				marginTop: '40px',
				marginBottom: '14px',
				marginLeft: { xs: '1rem', sm: 0 },
				justifyContent: 'center',
				'& .year': {
					fontWeight: 300
				}
			}}
		>
			<Typography level='h1' sx={{ marginBottom: '14px' }}>
				{heading || defaultHeading.split(` ${year}`)[0]} <span className='year'>{heading ? '' : year}</span>
			</Typography>
		</Box>
	);
};
